import * as yup from "yup";
import i18next from "i18next";

const t = (key: string) => i18next.t(key, { ns: "admin" }) as string;

export const validationSchemaPostalCode = yup.object().shape({
  postalCode: yup
    .string()
    .matches(/^[0-9]+$/)
    .max(6),
});


export const completeCorrectOrderValidation = yup.object().shape({
  tonnage: yup
    .string()
    .nullable()
    .matches(/^(\d+(?:[\.,]\d{1,2})?)$/, () => t("orders.validation.maxTwoDecimals"))
});

export const completeOrderValidation = yup.object().shape({
  driver: yup.string().required(() => t("orders.validation.selectDriver")),
  tonnage: yup
    .string()
    .required(() => t("orders.validation.enterTonnage"))
    .matches(/^(\d+(?:[\.\,]\d+)?)$/, () => t("orders.validation.enterNumber")),
  kpo: yup
    .string()
    .required(() => t("orders.validation.enterKpo")),
  operator: yup.string().required(() => t("orders.validation.selectOperator")),
  quantity: yup
    .string()
    .required(() => t("orders.validation.enterQuantity"))
    .matches(/^[0-9]+$/, () => t("orders.validation.enterInteger")),
  quantityTaken: yup
    .string()
    .required(() => t("orders.validation.enterQuantity"))
    .matches(/^[0-9]+$/, () => t("orders.validation.enterInteger")),
  // vatRate: yup
  //   .string()
  //   .required("podaj wartość VAT")
  //   .matches(/^[0-100]+$/, "podaj liczbę całkowitą")
  internalStoreId: yup
      .string()
      .required(() => t("orders.validation.selectWarehouse"))
});

export const newOrderValidation = yup.object().shape({
  receptionPlace: yup.string().required(() => t("orders.validation.selectReceptionPlace")),
  department: yup.string().required(() => t("orders.validation.selectDepartment")),
  orderTypeItemId: yup.string().required(() => t("orders.validation.selectVehicle")),
});

export const newOrderValidationShort = yup.object().shape({
  receptionPlace: yup.string().required(() => t("orders.validation.selectReceptionPlace")),
  orderTypeItemId: yup.string().required(() => t("orders.validation.selectVehicle")),
});

export const reportClientValidation = yup.object().shape({
  createdFrom: yup.string().required(() => t("orders.validation.selectDate")),
  createdTo: yup.string().required(() => t("orders.validation.selectDate")),
  currentStatus: yup.string().required(() => t("orders.validation.selectStatus")),
  orderBy: yup.string().required(() => t("orders.validation.selectColumn")),
  desc: yup.string().required(() => t("orders.validation.selectDirection")),
});

export const validationSchemaSyncOrder = yup.object().shape({
  numberOptima: yup.string().required(() => t("orders.validation.enterOptimaNumber")),
});
